import gameState from "slotworks/model/game-state";
import Record from "slotworks/model/gameplay/records/record";
import RequestPayload from "slotworks/model/gameplay/requests/request-payload";
import commsManager from "slotworks/server/comms-manager";
import RecordDisplay from "./record-display";
import RecordTree from "./record-tree";
import RequestButtons, { RequestButton } from "./request-buttons";
import ResultDisplay, { ResultDisplayFunction } from "./result-display";

export default class IntegrationDebugger {

    public static addRequest(label: string, requestType: new (...args: any[]) => RequestPayload, parameters?: string[]) {
        this.customRequests.push({ label, requestType, parameters });
    }

    public static addResultDisplayFunction(resultType: string, resultDisplay: ResultDisplayFunction) {
        this.customResultDisplays.set(resultType, resultDisplay);
    }

    private static customRequests: RequestButton[] = [];
    private static customResultDisplays: Map<string, ResultDisplayFunction> = new Map();

    private recordTree: RecordTree;
    private recordDisplay: RecordDisplay;
    private resultDisplay: ResultDisplay;
    private requestButtons: RequestButtons;

    public start() {
        this.recordTree = new RecordTree();
        this.recordDisplay = new RecordDisplay();
        this.resultDisplay = new ResultDisplay(IntegrationDebugger.customResultDisplays);
        this.requestButtons = new RequestButtons(IntegrationDebugger.customRequests);

        this.requestButtons.select.add((payload: RequestPayload) => this.sendRequest(payload));

        this.recordTree.select.add((record: Record) => this.recordDisplay.show(record));
        this.recordTree.select.add((record: Record) => this.resultDisplay.show(record));

        this.recordTree.update();
    }

    public toggle() {
        if (!this.recordDisplay || !this.recordDisplay || !this.resultDisplay || !this.requestButtons) {
            if (gameState.getCurrentGame().getCurrentRecord()) {
                this.start();
            }
        } else {
            this.recordTree.toggle();
            this.recordDisplay.toggle();
            this.resultDisplay.toggle();
            this.requestButtons.toggle();

            this.recordTree.update();
        }
    }

    private sendRequest(payload: RequestPayload) {
        if (gameState.getCurrentGame().hasRecords() && gameState.getCurrentGame().isComplete()) {
            gameState.newGame();
        }

        this.requestButtons.setEnabled(false);

        commsManager.request(payload).then(() => {
            this.requestButtons.setEnabled(true);
            gameState.getCurrentGame().latestRecord();
            const record = gameState.getCurrentGame().getCurrentRecord();
            if (record) {
                this.recordTree.update();
            }
        });
    }
}
